module.exports = __webpack_public_path__ + "img/longnan.43f7a8ce.jpg";